import InfoSection from '../components/info_section';
import ScrollButton from '../components/scroll_button';
import Layout from '../components/layout';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import styles from '../styles/artifactory.module.scss';
import Image from 'next/image';

export default function Artifactory() {
  const router = useRouter();
  const { t } = useTranslation('artifactory');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
      <InfoSection title='Artifactory' description='artifactoryDescription' documentationLink='https://help.icdc.io/artifactory/' lang={router.locale} />

      <div className={'flex ' + styles.provision}>
        <div>
          <h2>{t('workflow.title')}</h2>
          <p>{t('workflow.description1')}</p>
          <p>{t('workflow.description2')}</p>
        </div>
        <div>
          <h3>{t('provision.title')}</h3>
          <p>{t('provision.description1')}</p>
          <p>{t('provision.description2')}</p>
          <p>{t('provision.description3')}</p>
          <p>{t('provision.description4')}</p>
        </div>
      </div>

      <section className={styles.tools}>
        <h2>{t('formats_support.title')}</h2>
        <p>{t('formats_support.description1')}</p>
        <p>{t('formats_support.description2')}</p>
        <p>{t('formats_support.description3')}</p>
      </section>

      <div className={styles.supply_chain}>
        <div>
          <h2>{t('supply_chain.title')}</h2>
          <p>{t('supply_chain.description1')}</p>
          <p>{t('supply_chain.description2')}</p>
        </div>
        <Image src='/health.webp' alt='Health' width={543} height={375} unoptimized loading='lazy' />
      </div>

      <section className={styles.integration}>
        <h2>{t('integration.title')}</h2>
        <p>{t('integration.description1')}</p>
        <p>{t('integration.description2')}</p>
      </section>
    </Layout>
  )
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['artifactory', 'common']),
  },
});
